/*global jQuery, BulkWP*/
BulkWP.validateCommentsCount = function(that) {
    return ("" !== jQuery(that).parent().prev().children().find(":input.comments_count_num").val());
};
